<template>
  <div class="gw-template generic-border">
    <div class="gw-template__info v-centerer gw-template__basis-name">
      <EllipsisDiv class="gw-template__info__wrapper v-centerer" :text="name" :style="nameStyles" />
    </div>

    <div class="gw-template__basis-duration v-centerer">
      <Icon>{{ icons.clockMedium }}</Icon>
      <span>{{ duration }}</span>
    </div>

    <div class="gw-template__basis-button gw-template__start h-v-centerer">
      <button
        class="generic-border generic-border--icon-button generic-border--blue-border"
        @click="$emit('start')"
      >
        <Icon>{{ icons.startMedium }}</Icon>
      </button>
    </div>

    <div class="gw-template__basis-button h-v-centerer">
      <RouterLink
        :to="createGwCreationLink(gw.id, $route)"
        class="generic-border generic-border--icon-button generic-border--blue-border"
      >
        <Icon>{{ icons.editMedium }}</Icon>
      </RouterLink>
    </div>

    <div class="gw-template__basis-button h-v-centerer">
      <button class="generic-border generic-border--icon-button generic-border--blue-border" @click="$emit('copy')">
        <Icon>{{ icons.copyMedium }}</Icon>
      </button>
    </div>

    <div class="gw-template__basis-button h-v-centerer">
      <button class="generic-border generic-border--icon-button generic-border--blue-border" @click="deleteTemplate">
        <Icon>{{ icons.deleteMedium }}</Icon>
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Comonents used to display a GW template item and its options
 *
 * @vue-prop {Object} gw - Related GW template object
 */

// Components
import EllipsisDiv from '@/components/ellipsize.vue';
import Icon from '@/components/icon.vue';
// Import utils
import { calert, secondsToArray, decodeHTML } from '@/utils/main';
import { createGwCreationLink } from '@/utils/navigation';
import * as icons from '@/assets/icons';


export default {

  name: 'GwTemplate',

  components: {
    EllipsisDiv,
    Icon,
  },

  props: {
    gw: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      icons,
    };
  },

  computed: {
    duration() {
      const time = this.gw.duration ? secondsToArray(this.gw.duration) : ['0', '00', '00'];
      return `${time[0]}:${time[1]}:${time[2]}`;
    },
    nameStyles() {
      return {
        'font-weight': this.gw.name ? undefined : '100',
      };
    },
    name() {
      return decodeHTML(this.gw.name) || this.$t('message.GW_NO_NAME');
    },
    /** Boolean: Whether the GW can be edited and deleted */
    editable() {
      return this.gw.team === this.currentTeam.id;
    },
  },

  methods: {
    createGwCreationLink,
    deleteTemplate() {
      calert(this.$t('message.GW_TEMPLATE_CONFIRM_DELETE'), [
        {
          title: this.$t('message.DELETE'),
          sClass: 'red',
          action: () => {
            this.$emit('delete');
          },
        }, {
          title: this.$t('message.CANCEL'),
        },
      ]);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.gw-template {
  background-color: #fff;
  margin-top: 10px;
  padding: .64em 1.43rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  &__info {

    &__wrapper {
      flex: 1;
      min-width: 0px;
      font-weight: 600;
      line-height: 1.25rem;
      height: 2.5rem;
    }
  }

  &__start {
    color: $color-shizen-green;
  }

  &__basis-name {
    flex: 1 0 calc(85% - 32rem);
    margin-right: 1rem;
    min-width: 0px;
  }

  &__basis-duration {
    flex: 0 0 6rem;
    margin-right: 14.5%;
    width: 6rem;

    .icon {
      width: 1rem;
      height: 1rem;
      margin-right: .5rem;
      flex: 0 0 auto;
    }
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
    }
  }

  &__basis-button {
    flex: 0 0 6.5rem;

    &:last-child {
      margin-left: 1.85rem;
      flex: 0 0 auto;
    }
  }
}

@media (max-width: $tablet-landscape) {
  .gw-template {
    &__basis-duration {
      margin-right: 7%;
    }
  }
}

@media (max-width: $smartphone-landscape) {
  .gw-template {
    &__basis-duration {
      margin-right: 2.5%;
    }

    &__basis-button {
      flex: 0 0 4.5rem;

      &:last-child {
        margin-left: .85rem;
      }
    }
  }
}

@media (max-width: $smartphone-portrait) {
  .gw-template {
    &__basis-duration {
      margin-right: .5%;
    }

    &__basis-button {
      flex: 0 0 4rem;

      &:last-child {
        margin-left: .6rem;
      }
    }
  }
}

@media (max-width: $small-smartphone-portrait) {
  .gw-template {
    &__basis-duration {
      display: none;
    }
  }
}
</style>
